<template>
  <v-app>
    <div class="overall">
      <navbar v-if="login_verified == true" />
      <router-view></router-view>
      <div class="grey-background" v-if="login_verified == true">
        <sidebar :linkItems="linkItems" />
        <div class="hidden"></div>
      </div>
    </div>
  </v-app>
</template>

<script>
import Vue from "vue";

import { Plugin } from "vue-fragment";
Vue.use(Plugin);

import LangSelect from "./components/LangSelect";
import VueTheMask from "vue-the-mask";

import vSelect from "vue-select";
Vue.component("v-select", vSelect);
import "vue-select/dist/vue-select.css";

Vue.component("lang-select", LangSelect);
Vue.use(VueTheMask);

import navbar from "./components/Navbar";
import sidebar from "./components/Sidebar";

export default {
  name: "App",
  components: {
    navbar,
    sidebar
  },
  data() {
    return {
      linkItems: [
        {
          text: "Dashboard",
          imgsrc: "/assets/images/sidebar/1.png",
          link: "/dashboard"
        },
        {
          text: "Configuration",
          imgsrc: "/assets/images/sidebar/2.png",
          model: true,
          children: [
            { text: "Upload", link: "/configuration/upload" },
            { text: "Analysis", link: "/configuration/analysis" },
            { text: "Settings", link: "/configuration/settings" },
            { text: "Ruleset", link: "/configuration/ruleset" }
          ]
        },
        {
          text: "Enumeration",
          imgsrc: "/assets/images/sidebar/3.png",
          model: true,
          children: [
            { text: "Search", link: "/enumeration/search" },
            { text: "Notifications", link: "/enumeration/notifications" },
            { text: "Browse", link: "/enumeration/browse" }
          ]
        },
        {
          text: "IdM Settings",
          imgsrc: "/assets/images/sidebar/4.png",
          link: "/idmsettings"
        }
      ]
    };
  },
  mounted() {
    this.$store.state.auth.login_verified = localStorage.getItem(
      "login_verified"
    )
      ? true
      : false;
  },
  computed: {
    login_verified() {
      return this.$store.state.auth.login_verified;
    }
  }
};
</script>

<style lang="scss">
@import "./assets/styles/app.scss";
</style>
